import { createSelector, createStructuredSelector } from 'reselect'

import { SingleInfo } from './SidebarTariffInfo'

import { selectAllBundlesSelected } from '~/bundles/store/bundles.selectors'
import { RootState } from '~/core/store/root.reducer'
import { selectCustomerFullName } from '~/customer/store/customer.selectors'
import { selectLinePhoneNumber } from '~/line/store/line.selectors'
import { formatPrices, formatPriceMonthToMonth } from '~/prices/prices.helpers'
import { selectTariffPriceFormatted, selectAllTariffsPrices } from '~/prices/prices.selectors'
import { selectTaxValue } from '~/prices/store/prices.selectors'
import { selectSelectedTariffName } from '~/tariff/store/tariff.selectors'

export const selectCustomerInformation = createSelector(selectCustomerFullName, (customerName) => {
  return /[a-zA-Z]/g.test(customerName) ? customerName : ''
})

const selectSidebarTariffPrices = createSelector(
  selectTariffPriceFormatted,
  formatPriceMonthToMonth,
)

const selectBundlesSidebar = createSelector(
  selectAllBundlesSelected,
  selectTaxValue,
  (bundles, tax) => {
    return bundles.map(({ name, price }) => ({
      name: name || '',
      prices: formatPriceMonthToMonth(formatPrices(price || [], tax)),
    }))
  },
)

export const selectTariffSidebarInformation = (id: string) =>
  createStructuredSelector<RootState, SingleInfo>({
    name: (state: RootState) => selectSelectedTariffName(state, id),
    prices: (state: RootState) => selectSidebarTariffPrices(state, id),
    phoneNumber: (state: RootState) => selectLinePhoneNumber(state, id),
    bundles: (state: RootState) => selectBundlesSidebar(state, id),
  })

export const selectTariffTotalPrices = createSelector(
  selectAllTariffsPrices,
  formatPriceMonthToMonth,
)
